import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AccountService } from "src/app/views/sessions/services/account.services";
import { environment } from 'src/environments/environment';
// import { Observable } from 'rxjs';
// import { from } from 'rxjs';

import {from, Observable} from 'rxjs';
import {mergeMap} from 'rxjs/operators';


@Injectable()
export class AuthInterceptor implements HttpInterceptor{
  constructor(private accountService: AccountService){}

   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url === environment.apiUrl + 'token'){
      console.log("Skip Req:",req.url);
      return next.handle(req);
    }
    return this.makeRequest(req).pipe(mergeMap((req2) => {
      return next.handle(req2);
    }));
  }
  
  private makeRequest(req :HttpRequest<any>): Observable<HttpRequest<any>> {
    console.log("Make Req",req.url);
      // if (!this.accountService.isRefreshing || this.accountService.isExpired())
    if (this.accountService.isExpired())
    {
      return from(this.accountService.refreshTokenAsync().then(() => {
        console.log("REFRESH TOKEN");
        return this.setTokenToHeader(req, this.accountService.accessToken)
        }));
    } else {
      console.log("REQUEST");
      return from(new Promise<HttpRequest<any>>((resolve) => 
        { 
          return resolve(this.setTokenToHeader(req, this.accountService.accessToken));
        }));
    }
  }

  private setTokenToHeader(req : HttpRequest<any>, idToken : string): HttpRequest<any>{
    const cloned= req.clone({
      headers: req.headers.set("authorization", "Bearer " + idToken)
    });
    return cloned;
  }
}
